import React, { useState } from 'react';
import './faq.css'
import Beard from '../../assets/images/logo-beard2.svg'
import Footer from '../../layout/footer/footer'
import { Accordion, Col, Form } from 'react-bootstrap';
import FaqAccordion from './faq-accordion';

function Faq() {
    return (
        <>
            <div className='container'>
                <div className='d-flex align-items-center title gap-3'><img src={Beard} alt="" />سوالات متداول</div>

                <div className="mt-5">
                  <FaqAccordion />
                </div>
            </div>
            <div className="home-footer mt-40">
                <Footer />
            </div>
        </>
    )
}

export default Faq